import React, { useEffect } from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';

import {
  ESIGN_ENDPOINT,
} from '../configurations';
import { messages } from './constants';
import Loading from '../shared/loading/loading';

const PARTNER_TOKEN_EXPIRY_DAYS = 30;

const PartnerAuth = () => {

  const sendToken = (token) => {

    axios
      .post(`${ESIGN_ENDPOINT + '/partner-auth'}`, {
        token,
      }, {
        // API returns a compact JWE string (not JSON); default JSON parse fails and rejects.
        responseType: 'text',
        timeout: 10000,
        timeoutErrorMessage: 'Request Timed Out',
      })
      .then((res) => {
      // If token is valid, set response JWT as cookie and redirect.
        Cookies.set('jwt', res.data, {
          expires: PARTNER_TOKEN_EXPIRY_DAYS,
          sameSite: 'lax',
        });
        window.location.href = '/agent/sessions';
      })
      .catch((reqError) => {
        console.log(`BE Auth Error: ${reqError}`);

        // If current token invalid, log user out (this includes missing required info).
        // Otherwise, may stay logged in under old account and user information would
        // not have been updated, which is not expected (and would cause debugging issues).
        Cookies.remove('jwt');
      });
  };

  useEffect(() => {
    // Check for presence of partner token in url.
    const params = new URL(String(document.location)).searchParams;
    const urlToken = params.get('ptoken') || '';

    sendToken(urlToken);

  }, []);

  // Loading timeout will occur with error message after 5s.
  return (
    <Loading
      message={messages.PARTNER_LOGGING_IN}
      enterDelay={200}
      timeout={5000}
      timeoutMessage={messages.PARTNER_LOGIN_ERROR}
    />
  );
};

export default PartnerAuth;

/*

# Partner integration instructions.

Create an object with these fields:

{
  // Required fields:
  partnerId: string, // eg. 'yourPartnerID' - You will be given a unique partner ID for our system.
  userId: string // eg. 'aeahgnb4ahg4' - unique user identifier in your system.
  email: string // eg. 'email@partner.com' - unique email. Used as unique ID for a user.
  firstName: string // eg. 'Dave' - first name.
  lastName: string // eg. 'Smith' - last name.
  exp: int // eg. 1575999583 - Unix timestamp of expiry. Cannot be more than 30 days in the future.
}

Sign it as a JWT token using HS256 and the private key which will be sent to you.

Make sure this is done on a backend, as the private key should never be exposed in frontend
code.

example Node.js-like pseudocode:

// On your backend

import * as jwt from "jsonwebtoken";

const backendAPISigningFunction = (requestContext) => {
  // Pull user info for the current authenticated user from the DB.
  const yourUser = requestContext.getCurrentUser();

  // Create a user package object to specification.
  // All fields are required.
  // IMPORTANT: Email is assumed to be verified by your system.
  const userPackage = {
    partnerId: yourPartnerId,
    userId: yourUser.id,
    email: yourUser.email,
    firstName: yourUser.firstName,
    lastName: yourUser.lastName,
    exp: 1575999583,
  };

  // Sign userPackage object.
  const token = jwt.sign(userPackage, config.jwtSecret);

  // Return packaged token to your frontend.
  return { token }
}

// On your frontend

frontendHandler = () => {
  // Call backend handler.
  const [response, err] = callBackendAPISigningFunction();

  // Forward to esig.ink address with appended token in URL.
  location.history.href = `https://esig.ink/partner-auth?token=${response.data.token}`
}

User will be automatically signed in to our system, and if the user has never signed
in before, a new account will automatically be created.

User data will be updated when new tokens are passed in, according to the unique email address.

Note that currently if users change email addresses, a new account will be created for them, so they will
no longer be accessing their old account. Therefore, they will not see deals they have already completed.

However, those deals will still exist in our system, attached to their old email address.

This flow may be updated in the future to support changing email addresses.

*/
